export default __webpack_public_path__ + "static/media/beestate_digital.4336d4f3.jpg";